import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsAuthorizationSchema = withDefaults({
  type: 'pcs-authorization',
  fields: [
    {
      kind: 'attribute',
      name: 'state',
    },
    {
      kind: 'attribute',
      name: 'provider',
    },
    {
      kind: 'attribute',
      name: 'providerId',
    },
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'providerData',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'pcsCard',
      type: 'pcs-card',
      options: {
        async: false,
        inverse: 'pcsAuthorizations',
      },
    },
    {
      kind: 'belongsTo',
      name: 'pcsNetworkMerchant',
      type: 'pcs-network-merchant',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PcsAuthorizationSchema;
